"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketWebsiteOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketWebsiteOutput.js.map